import React from 'react';
import { Routes, Route } from 'react-router-dom'
import { Home, About, NotFound } from './pages/index'

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
